import Axios, { Canceler, CancelTokenSource } from 'axios';
import { ImageMedia } from '../../../libs/ideine-web-richtext/Context/RichtextConfig';

import { StoreProvider } from '../../../libs/IdeLink.Web.Common/src/redux/StoreProvider';
import { ApiDataResponse } from '../../../libs/IdeLink.Web.Common/src/services/api/ApiResponse';
import { UploadData, UploadDataType, XHRRequest } from '../../../libs/IdeLink.Web.Common/src/services/api';
import { UploadProgressEvent } from '../../../libs/IdeLink.Web.Common/src/services/Events/ProgressEvent';
import { MediaItemResponse, UploadedVideoItemResponse } from '../../models/MediaItem';
import { MediasApiUrls } from './MediasApiUrls';
import { MediasUtils } from './MediasUtils';

const CancelToken = Axios.CancelToken;

export class MediasApi {

    public static openDocument = async (url: string): Promise<string> => {
        const token: string = await StoreProvider.getToken();
        const documentUrl = MediasUtils.toAuthenticatedUrlFromToken(url, token);
        window.open(documentUrl, '_blank');
        return Promise.resolve(documentUrl);
    };

    public static uploadDocument(pdfFile: File, onUploadProgress?: (event: UploadProgressEvent) => void, cancelTokenExecuter?: (cancel: Canceler) => void): Promise<MediaItemResponse> {
        const uploadData: UploadData = { type: UploadDataType.Document, value: pdfFile };
        return XHRRequest.upload<MediaItemResponse>(MediasApiUrls.DOCUMENT_UPLOAD, uploadData,
            {
                onUploadProgress,
                cancelToken: cancelTokenExecuter ? new CancelToken(cancelTokenExecuter) : undefined,
                shouldToast: true,
                trustSuccess: true
            },
        );
    }

    public static uploadDocumentByUrl(data: any) {
        return XHRRequest.post(MediasApiUrls.DOCUMENT_UPLOAD_FROM_URL, data);
    }

    public static uploadImage(image: File, onUploadProgress?: (event: UploadProgressEvent) => void, cancelTokenExecuter?: (cancel: Canceler) => void): Promise<MediaItemResponse> {
        const uploadData: UploadData = { type: UploadDataType.Image, value: image };
        return XHRRequest.upload<MediaItemResponse>(MediasApiUrls.IMAGE_UPLOAD, uploadData,
            {
                onUploadProgress,
                cancelToken: cancelTokenExecuter ? new CancelToken(cancelTokenExecuter) : undefined,
                shouldToast: true,
                trustSuccess: true
            },
        );
    }

    public static async uploadRteImage(file: File, onUploadProgress?: (progress: any) => void, cts?: CancelTokenSource): Promise<ImageMedia> {
        const uploadData: UploadData = { type: UploadDataType.Image, value: file };
        const upload = await XHRRequest.upload<ApiDataResponse<ImageMedia>>(MediasApiUrls.IMAGE_UPLOAD, uploadData,
            {
                onUploadProgress,
                cts,
                shouldToast: true,
                trustSuccess: true
            },
        );
        return upload.data;
    }

    public static uploadImageByUrl(url: string): Promise<MediaItemResponse> {
        const bodyRequest = { url };
        return XHRRequest.post<MediaItemResponse>(MediasApiUrls.IMAGE_UPLOAD_FROM_URL, bodyRequest);
    }

    public static uploadVideo(video: File, onUploadProgress?: (event: UploadProgressEvent) => void, cancelTokenExecuter?: CancelTokenSource) {
        const uploadData: UploadData = { type: UploadDataType.Video, value: video };
        return XHRRequest.upload<UploadedVideoItemResponse>(MediasApiUrls.VIDEO_UPLOAD, uploadData,
            {
                onUploadProgress,
                //cancelToken: cancelTokenExecuter ? new CancelToken(cancelTokenExecuter) : undefined,
                cts: cancelTokenExecuter,
                shouldToast: true,
                trustSuccess: true
            },
        );
    }

    public static getVideo(id: string): Promise<MediaItemResponse> {
        return XHRRequest.get<MediaItemResponse>(MediasApiUrls.VIDEO_URL(id));
    }

    public static openVideoFromId = async (videoMediaId: string) => {
        const response: MediaItemResponse = await MediasApi.getVideo(videoMediaId);
        window.open(response.data.url, '_blank');
    };
}

